<template>
  <div class="product-list-wrapper">
    <div class="col-md-4 pl-0 mb-4">
        <base-filter-bar placeholder="Search Assets by Product Traits"></base-filter-bar>
    </div>
    <div class="row pl-3 pb-1">
        <div class="col-md-1"></div>
        <div class="col-md-5">Product Name</div>
        <div class="col-md-4">Assets</div>
    </div>
    <div class="row product-row-background" v-for="product in productList" :key="product.id">
        <div class="col-md-1 d-flex justify-content-between align-items-center" >
            <div class="ml-2">
                <img class="product-thumbnail" v-if="product.thumbnailuri" :src="product.thumbnailuri" alt="">
                <img class="product-thumbnail" v-else-if="product.assets[0]" :src="product.assets[0].uri_internal" alt="">
                <i v-else class="fa fa-eye-slash fa-2x ml-2" style="color: #AB5755;"></i>
            </div>
        </div>
        <div class="col-md-5">
            <a :href="'/products/' + product.id + '/edit/v2'">{{product.name}}</a>
            <br>
            <span class="small-text">ID: {{product.id}}</span>
        </div>
        <div class="col-md-4">
            <div v-if="product.assets[0]" class="assets-container d-flex flex-column">
                <div class="ml-1 w-100 h-100">
                    <i class="fa fa-eye fa-2x" style="color: #3cab9f;"></i>
                </div>
                <div class="assets-container-overlay" @click="previewProductAssets(product.id)"></div>
            </div>
            <div v-else class="assets-container d-flex flex-column" style="maxHeight: 100px">
                <div class="ml-1 w-100 h-100">
                    No assets
                </div>
            </div>
        </div>
        <div class="col-md-1"><a class="btn btn-outline-primary" role="button" :href="'/products/' + product.id + '/edit/v2'">View</a></div>
    </div>
    <div class="d-flex justify-content-between pt-2 pb-5">
        <div class="col-md-4 pl-0">
            <select name="select-per-page" @change="handlePerPageChange" v-model="pageSize" class="form-control max-w-xs">
                <option v-for="(amount, index) in amountsShown" :key="index" :value="amount.value">{{amount.text}}</option>
            </select>
        </div>
        <div class="text-right">
            <paginator v-show="paginationData.last_page > 1" :showFirstLast="true" :pagination="paginationData" @paginate="handlePageChange"></paginator>
        </div>
    </div>
    <div class="load-indicator" v-show="showGeneralLoadIndicator">
        <span class="fa fa-cog fa-spin fa-1x"></span>
    </div>
    <transition name="fade">
        <div v-if="assetPreviewModal" class="modal-wrapper asset-preview-modal">
            <div class="modal-bg" @click="assetPreviewModal = false"></div>
            <div class="modal-inner p-4 asset-modal-inner">
                <div class="row mx-4 pb-1">
                    <p class="font-weight-bold" style="max-width: 46ch;">
                        {{ previewProduct.name }} Assets
                    </p>
                </div>
                <div class="row mx-4 my-0 pb-0 asset-preview-images">
                    <div v-for="(asset, index) in previewProduct.assets" :key="asset.id" class="asset-preview-image" :class="{ 'mt-4' : index > 0 }">
                        <a :href="'/assets/' + asset.id + '/edit'">
                            <img :src="asset.uri_internal" :alt="asset.name">
                        </a>
                    </div>
                </div>
                <div class="row mx-4 my-0 pb-0 d-flex flex-column">
                    Click on preview image to view asset
                </div>
            </div>
        </div>
    </transition>
    <product-alerts :status="alert" v-model="alert"></product-alerts>
  </div>
</template>

<script>
import axios from "axios";
import TablePagination from "../generic/tables/pagination.vue";
import ProductAlerts from '../products/product-details-alerts.vue';
import BaseFilterBar from '../tables/base-filter-bar.vue'


const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "dam-products",
    components: {
        paginator: TablePagination,
        'product-alerts': ProductAlerts,
        'base-filter-bar': BaseFilterBar,
    },
    data() {
        return {
            showGeneralLoadIndicator: true,
            filterText: '',
            pageSize: 25,
            currentPage: 1,
            filterProducts: 0,
            previewProduct: {
                assets: [],
                id: null,
                name: ''
            },
            assetPreviewModal: false,
            productList: [],
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
            amountsShown: [
                { text: "Products Per Page: 10", value: 10 },
                { text: "Products Per Page: 25", value: 25 },
                { text: "Products Per Page: 50", value: 50 },
                { text: "Products Per Page: 100", value: 100 }
            ]
        };
    },
    mounted() {
        this.$events.$on('filter-set', e => this.onFilterSet(e))
        this.$events.$on('filter-reset', e => this.onFilterReset())
        this.fetchProductList();
    },
    computed: {
        paginationData() {
            return {
                current_page: this.currentPage,
                last_page: Math.ceil(this.filterProducts / this.pageSize),
                to: true
            };
        },
    },
    watch: {
        pageSize: {
            handler: function() {
                this.fetchProductList();
            }
        },
        currentPage: {
            handler: function() {
                this.fetchProductList();
            }
        },
        filterText: {
            handler: function() {
                this.currentPage = 1;
            }
        }
    },
    methods: {
        handlePerPageChange() {
            this.from = 0;
            this.currentPage = 1;
            this.fetchProductList();
        },
        handlePageChange(page) {
            this.currentPage = page;
            this.from = this.pageSize * (page - 1);
            this.fetchProductList();
        },
        previewProductAssets(id) {  
            let previewProduct = this.productList.filter(product => product.id === id)[0];
            this.previewProduct.assets = previewProduct.assets;
            this.previewProduct.name = previewProduct.name;
            this.previewProduct.id = previewProduct.id;
            this.assetPreviewModal = true
        },
        doVisibleSet (perPageValue) {
            this.perPage = perPageValue;
            this.$nextTick(() => this.fetchProductList());
        },
        onFilterSet: _.debounce(function (e) {
            this.filterText = e;
            this.$nextTick(() => this.fetchProductList());
        }, 300),
        onFilterReset () {
            this.filterText = '';
            this.$nextTick(() => this.fetchProductList());
        },
        fetchProductList() {
            this.showGeneralLoadIndicator = true;

            let fromValue = (this.currentPage - 1) * this.pageSize;
            let queryParams = `?&from=${fromValue}&size=${this.pageSize}`;

            if (this.filterText.length) {
                queryParams = queryParams + `&q=${this.filterText}`
            }

            axios
                .get(base_url + "/pimapi/assets/product/search" + queryParams)
                .then((response) => {
                    this.showGeneralLoadIndicator = false;
                    this.filterProducts = response.data.recordsFiltered;
                    this.productList = response.data.data.map((item) => item);
                    
                    return response;
                })
                .catch(error => {
                    console.log("product list error:", error);
                    this.showGeneralLoadIndicator = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.product-list-wrapper {
    .product-row-background {
        background-color: white;
        border: 1px solid #d6d9da;
        border-radius: 5px;
        padding: 0px;
        margin: 0px 0px 4px 0px;
        display: flex;
        align-items: center;
        height: auto;
        min-height: 4rem;
    }
}

.product-thumbnail {
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #dedede;
    object-fit: cover;
}

.assets-container {
    max-width: 100px; 
    z-index: 1;
    position: relative;
}

.assets-container-overlay {
    width: 100%;
    height: 100%;
    z-index: 3;
    cursor: pointer;
    position: absolute;
}

.asset-modal-inner {
    max-width: 80vw;
    max-height: 80vw;
}

.asset-preview-images {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 64vh;
    max-width: 56vh;
    height: 100%;
    border-radius: 2px;
    border: 1px solid #dedede;
}

.asset-preview-image {
    width: 100%;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;

        &:hover {
            filter: brightness(0.9);
        }
    }
}
</style>